import * as z from "zod/v4";

export const addressHumanInputSchema = z.strictObject({
	street1: z.string().trim().min(1),
	street2: z.string().trim().min(1).optional(),
	city: z.string().trim().min(1),
	state: z.string().trim().min(1),
	zipCode: z.string().trim().min(1).optional()
});

export type AddressHumanInput = z.infer<typeof addressHumanInputSchema>;

export const addressShapeSchema = z.object({
	addressStreet1: z.string().min(1),
	addressStreet2: z.string().nullable(),
	addressCity: z.string().min(1),
	addressState: z.string().min(1),
	addressPostcode: z.string().min(1),
	addressCounty: z.string().min(1),
	addressLat: z.number().nullable(),
	addressLng: z.number().nullable(),
	placeId: z.string().nullable(),
	validated: z.boolean()
});

export type AddressShape = z.infer<typeof addressShapeSchema>;

export const validateAddressInputSchema = z.object({
	street1: z.string(),
	street2: z.string().optional(),
	city: z.string(),
	state: z.string(),
	zipCode: z.string().optional()
});

export type ValidateAddressInput = z.infer<typeof validateAddressInputSchema>;

export interface ValidatedAddress {
	isValid: boolean;
	formattedAddress: string | null;
	street1: string;
	street2: string | null;
	streetNumber: string | null;
	streetName: string | null;
	streetUnit: string | null;
	city: string;
	state: string;
	zipCode: string | null;
	county: string | null;
	latitude: number | null;
	longitude: number | null;
	placeId: string | null;
}
